//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MBD.js";
import "../no/TaggedObject.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Clearance",1,0],[0,"FindSimilar",1,0],[0,"GroupResults",1,0],[0,"Scope",1,0],[1,"ScopedSelectionParts",0,"SelectNXObjectList",0],[1,"SeedObjects",0,"SelectNXObjectList",0],[0,"ShowVisualTags",1,0]],[[[],"ButtonUp",{},0,0],[[],"ButtonDown",{},0,0],[[],"ButtonDeEmphasize",{},0,0],[["resultFaces"],"FindSemanticFeatures",{R_:{featureDataTag:"MBD.SemanticFeatureData"}},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.MBD.SemanticTopologyBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MBD.SemanticTopologyBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MBD.SemanticTopologyBuilder.ScopeForFindSimilar = Object.freeze({
    "EntirePart" : "EntirePart", "Selected" : "Selected"});

export default SPLM;